// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__1MxSP","splide":"splide__33ZnS"};


//////////////////
// WEBPACK FOOTER
// ./components/slider/style.styl
// module id = vMaB
// module chunks = 0